import gql from 'graphql-tag';

export const CheckLdpLicense = gql`
  query CheckLdpLicense($licenseNumber: String) {
    checkLdpLicense(licenseNumber: $licenseNumber) {
      id
      fullName
      firstName
      lastName
      emailAddress1
      emailAddress2
      telephone1
      telephone1sms
      telephone2
      telephone2sms
      address1_Line1
      address1_Line2
      address1_City
      address1_StateOrProvince
      address1_PostalCode
      isEngineer
      ldpLicenseType
      ldpLicenseNumber
      ldpLicenseExpiration
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      webSiteUrl
    }
  }
`;

export const ListLdpZipQuery = gql`
  query contactLdpProximityZIP ($zip: String) {
    contactLicensedDesignProfessionalProximityZIP (zipcode: $zip) {
        id
        firstName
        lastName
        fullName
        businessName
        emailAddress1
        emailAddress2
        telephone1
        address2_Line1
        address2_Line2
        address2_City
        address2_StateOrProvince
        address2_PostalCode
        address2_Telephone1
        address2_Latitude
        address2_Longitude
        webSiteUrl
        ldpLicenseNumber
        ldpLicenseExpiration
        ldpLicenseTypeOptionSet
        advertiseYourself
    }
  }
`;

export const ListLdpFilterQuery = gql`
  query contactLdpFilter ($filter: String) {
    contactLicensedDesignProfessionalFilter (filter: $filter) {
        id
        firstName
        lastName
        fullName
        businessName
        emailAddress1
        emailAddress2
        telephone1
        address2_Line1
        address2_Line2
        address2_City
        address2_StateOrProvince
        address2_PostalCode
        address2_Telephone1
        address2_Latitude
        address2_Longitude
        webSiteUrl
        ldpLicenseNumber
        ldpLicenseExpiration
        ldpLicenseTypeOptionSet
        advertiseYourself
    }
  }
`;
